import { render, staticRenderFns } from "./rec-products.vue?vue&type=template&id=139867e5&scoped=true"
import script from "./rec-products.vue?vue&type=script&lang=js"
export * from "./rec-products.vue?vue&type=script&lang=js"
import style0 from "./rec-products.vue?vue&type=style&index=0&id=139867e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139867e5",
  null
  
)

export default component.exports